import { render, staticRenderFns } from "./NoAuthority.vue?vue&type=template&id=4c7024fe&scoped=true"
import script from "./NoAuthority.vue?vue&type=script&lang=js"
export * from "./NoAuthority.vue?vue&type=script&lang=js"
import style0 from "./NoAuthority.vue?vue&type=style&index=0&id=4c7024fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7024fe",
  null
  
)

export default component.exports